
define('text!templates/appMain/privilegedMain/qm/interactionsListAgentCellTooltip.html',[],function () { return '<div data-bind="foreach: agentNames">\n    <div data-bind="text: $data"></div>\n</div>';});

